<script setup>
    const store = useStore()

    const { data: quoteBuilder } = await useStatamicGlobals().getGlobal({
        handle: 'quote_builder',
    })
</script>

<template>
    <div class="flex w-full flex-col items-start gap-8 sm:gap-4 lg:gap-6">
        <QuoteBuilderForm />

        <QuoteBuilderHeader
            :title="quoteBuilder.step_1_title"
            :subTitle="quoteBuilder.step_1_sub_heading"
            :currentStep="1"
            class="container"
        />

        <CarsList :cars="store.availableCars" />
    </div>
</template>

<style>
    .cars-container {
        @screen sm {
            > div {
                padding-inline: 0;
            }
        }
    }
</style>
